// extracted by mini-css-extract-plugin
export default {"container":"kp-z"};